import { prequalificationForm, contentFulFields } from '../utils/constant';

const {
  existingInternetConnection,
  telusWorkplace,
  fieldCustomerSegment,
  fieldMobileOrVoiceEdition
} = contentFulFields[prequalificationForm];

export const isChannelBSEorBSW = (fields, name, no, valueSegmentSmb1To30) => {
  if (name === existingInternetConnection) {
    if (
      (fields[fieldCustomerSegment].value === valueSegmentSmb1To30 &&
        fields[fieldMobileOrVoiceEdition].value === no) ||
      (fields[fieldCustomerSegment].value !== valueSegmentSmb1To30 &&
        fields[telusWorkplace].value === no)
    )
      return true;
    return false;
  }
  return undefined;
};

export const getValueFromEligibleStep = () => undefined;
